import { useLazyQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { GetCheckinEntryDetailDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { checkinNotifyConfirmModalState } from '~/state/reception/atoms';

export const useGetCheckinEntryProfile = () => {
  const { isOpen, checkinEntryId } = useAtomValue(checkinNotifyConfirmModalState);
  const [getCheckinEntryProfile, { data, error, loading }] = useLazyQuery(
    GetCheckinEntryDetailDocument,
  );
  const checkinEntry = getNode(data, 'CheckinEntry');

  useEffect(() => {
    if (isOpen && checkinEntryId) {
      getCheckinEntryProfile({ variables: { id: checkinEntryId } });
    }
  }, [isOpen, checkinEntryId, getCheckinEntryProfile]);

  return { checkinEntry, error, loading };
};
